import * as React from 'react'

import {
  Box,
  Button,
  Icon,
  List,
  Tag,
  Text,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface Props {
  name: string
  description: string
  onRemove: () => void
  id?: number | null
}

const Item: React.FC<Props> = ({ name, description, onRemove, id }) => {
  const [open, toggle] = useToggle(false)

  const handleRemove = () => {
    track(trackingEvents.jobCatalog.aiCompetenciesCreatedDelete)
    onRemove()
  }

  return (
    <List.Item>
      <Box flexDirection="column" gap="s12" width="full">
        <Box alignSelf="start">
          {id ? (
            <Tag type="grey">{i18n.t('job_catalog.competencies.ai_autofill_from_library')} </Tag>
          ) : (
            <Tag type="viridian" solid>
              {i18n.t('job_catalog.competencies.ai_autofill_new')}
            </Tag>
          )}
        </Box>
        <Box flexDirection="row" justifyContent="spaceBetween" width="full">
          <Box flexDirection="row" gap="s8" alignItems="center">
            <Tooltip.Alt
              open={open}
              toggle={toggle}
              attachment="bottom center"
              label={description}
              textAlign="center"
            >
              <Icon.Medium icon="info-circle-line" color="grey800" />
            </Tooltip.Alt>
            <Text.Normal color="grey1000" weight="medium">
              {name}
            </Text.Normal>
          </Box>
          <Button type="secondary" onClick={handleRemove} iconName="delete" />
        </Box>
      </Box>
    </List.Item>
  )
}

export default Item
